import { gql } from '@apollo/client/core';
import PostPreview from '@/apollo/fragments/Notification/NotificationPostPreview.fragment';
import CommentPreview from '@/apollo/fragments/Notification/NotificationCommentPreview.fragment';

const NotificationRatingPreviewFragment = gql`
  ${PostPreview}
  ${CommentPreview}

  fragment RatingPreview on Rating {
    id
    value
    user {
      ...UserPreview
    }
    reactable {
      ... on Post {
        ...PostPreview
      }
      ... on Comment {
        ...CommentPreview
      }
    }
  }
`;

export default NotificationRatingPreviewFragment;
